import config from "config/appConfig";

import type {
	UserDocumentTypeModel,
	UserDocumentValidationModel,
	UserModel,
	UserProfileModel
} from "shared/types/UserModel";
import type { IStateProps } from "utils/StateOf";
import createStoreFunction from "utils/createStore";

import type { BonusModel } from "../../types/BonusModel";
import type { UserTournamentModel } from "../../types/UserTournamentModel";
import type { UserTransactionModel } from "../../types/UserTransactionModel";

const localStorageKey = `${config.GLOBAL_CONSTANTS.LOCAL_STORAGE_PREFIX}${config.HOOK_STORAGE_KEYS.USER_DATA}`;

export interface Values {
	loading: boolean;
	profile?: UserProfileModel;
	user?: UserModel;

	loadingTransactions: boolean;
	transactions: UserTransactionModel[];

	loadingBonusHistory: boolean;
	bonusHistory: BonusModel[];

	loadingTournamentsHistory: boolean;
	tournamentsHistory: UserTournamentModel[];

	validatingDocument: boolean;
	checkingDocumentValidations: boolean;
	documentValidations: UserDocumentValidationModel[];
	documentTypes: UserDocumentTypeModel[];
}

export const initialState: IStateProps<Values> = {
	loading: false,
	profile: undefined,
	user: undefined,

	loadingTransactions: false,
	transactions: [],

	loadingBonusHistory: false,
	bonusHistory: [],

	loadingTournamentsHistory: false,
	tournamentsHistory: [],

	validatingDocument: false,
	checkingDocumentValidations: false,
	documentValidations: [],
	documentTypes: []
};

export default createStoreFunction<Values>({
	initialState,
	persistant: true,
	persistantName: localStorageKey
});
